import { render, staticRenderFns } from "./Layout_PostCreation_Modal.vue?vue&type=template&id=3953e4fa&"
import script from "./Layout_PostCreation_Modal.vue?vue&type=script&lang=js&"
export * from "./Layout_PostCreation_Modal.vue?vue&type=script&lang=js&"
import style0 from "./Layout_PostCreation_Modal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports